/** Normalise a URL before rendering as an outbound href.
 * Prevents browser "security violation" warnings caused by:
 *  - URLs without protocol (treated as relative paths)
 *  - javascript:, data:, vbscript:, file: schemes
 *  - URL-encoded control characters (e.g. %1B from c2c webitrent)
 *  - Browser-bound session tokens that expire and trigger
 *    deep-link rejection messages from career portals.
 */
const SESSION_KEYS = new Set([
  "usession", "wvid", "jsessionid", "sessionid", "session", "sid",
  "phpsessid", "aspsessionid", "asp.net_sessionid", "_session",
]);

export function safeUrl(url) {
  if (!url || typeof url !== "string") return "";
  let u = url.trim();
  if (!u) return "";
  const lower0 = u.toLowerCase();
  if (lower0.startsWith("javascript:") || lower0.startsWith("data:") || lower0.startsWith("vbscript:") || lower0.startsWith("file:")) return "";
  // Replace percent-encoded control chars (00-1F, 7F) with &
  u = u.replace(/%(0[0-9a-fA-F]|1[0-9a-fA-F]|7[fF])/g, "&");
  // Strip literal control chars
  u = u.split("").filter((ch) => {
    const code = ch.charCodeAt(0);
    return code >= 0x20 && code !== 0x7F;
  }).join("");
  // Collapse double ampersands
  u = u.replace(/&{2,}/g, "&");
  // Strip jsessionid embedded in path
  u = u.replace(/;jsessionid=[^?#/]+/gi, "");
  // Strip session params from query string
  if (u.includes("?")) {
    const [head, qs] = u.split(/\?(.*)/s);
    const kept = (qs || "").split("&").filter((part) => {
      if (!part) return false;
      const key = part.split("=")[0].toLowerCase();
      return !SESSION_KEYS.has(key);
    });
    u = head + (kept.length ? "?" + kept.join("&") : "");
  }
  const lower = u.toLowerCase();
  if (lower.startsWith("http://") || lower.startsWith("https://") || lower.startsWith("mailto:") || lower.startsWith("tel:")) return u;
  return "https://" + u;
}
